<button
  type="button"
  class="lum-button lum-button--secondary lum-c-hubspot-connect-button"
  (click)="open()"
  [disabled]="disabled"
>
  Connect HubSpot
</button> 